<template>
<div class="row g-4">
  <div class="col-lg-3">
    <div class="card shadow-none border border-radius-lg h-100">
      <div class="card-body p-3">
        <ul class="nav nav-pills flex-column bg-transparent" id="myTabs">
          <li class="nav-item">
            <a class="nav-link mb-2 p-3 text-start d-flex align-items-center" data-bs-toggle="tab" href="#tab10">
              <div class="icon icon-shape icon-xs shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                <font-awesome-icon icon="file-circle-plus" class="text-dark" />
              </div>
              <span class="nav-link-text font-weight-bold">Crear Plantilla</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link mb-2 p-3 text-start d-flex align-items-center" data-bs-toggle="tab" href="#tab11">
              <div class="icon icon-shape icon-xs shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                <font-awesome-icon icon="list" class="text-dark" />
              </div>
              <span class="nav-link-text font-weight-bold">Lista de Plantillas</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link mb-2 p-3 text-start d-flex align-items-center" data-bs-toggle="tab" href="#tab12">
              <div class="icon icon-shape icon-xs shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                <font-awesome-icon icon="keyboard" class="text-dark" />
              </div>
              <span class="nav-link-text font-weight-bold">Envío Directo</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link mb-2 p-3 text-start d-flex align-items-center active" data-bs-toggle="tab" href="#tab13">
              <div class="icon icon-shape icon-xs shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                <font-awesome-icon icon="paper-plane" class="text-dark" />
              </div>
              <span class="nav-link-text font-weight-bold">Enviar con Plantilla</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col-lg-9 col-md-8 col-sm-12">
    <div class="tab-content">
      <!--      ======================== START TAB 1 =======================-->
      <div class="tab-pane fade" id="tab10" role="tabpanel">
        <div class="card shadow-none border-0">
          <div class="card-body p-0">
            <h5 class="font-weight-bolder mb-3">Nueva Plantilla</h5>
            <div class="row">
              <div class="col-md-8">
                <div class="form-group mb-3">
                  <label class="form-control-label">Título de la Plantilla</label>
                  <input type="text" class="form-control" v-model="template.title" placeholder="Ej: Bienvenida Cliente">
                </div>
              </div>
              <div class="col-md-4" v-if="$userCan('administrator')">
                <div class="form-group mb-3">
                  <label class="form-control-label">Visibilidad (Rol)</label>
                  <select class="form-control" v-model="template.permission">
                    <option value="all">Todos</option>
                    <option value="administrator">Administrador</option>
                    <option value="agent">Agente</option>
                  </select>
                </div>
              </div>
            </div>
            
            <div class="form-group mb-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="form-control-label mb-0">Contenido del Mensaje</label>
                <button class="btn btn-link text-primary text-xs mb-0 p-0" @click="copyToClipboard">
                  <font-awesome-icon icon="copy" class="me-1" />
                  Copiar variable ${ }
                </button>
              </div>
              <p class="text-xs text-muted mb-2">
                <font-awesome-icon icon="circle-info" class="me-1" />
                Usá <strong>${}</strong> para definir variables dinámicas. Ej: Hola, ${nombre}
              </p>
              <ckeditor :editor="editor" v-model="template.description" :config="editorConfig"></ckeditor>
            </div>
            
            <button class="btn bg-gradient-primary w-100 mt-3" @click="saveTemplate">
              <font-awesome-icon icon="save" class="me-1" />
              Guardar Plantilla
            </button>
          </div>
        </div>
      </div>

      <!--      ======================== END TAB 1 =======================-->
      <!--      ======================== START TAB 2 =======================-->
      <div class="tab-pane fade" id="tab11" role="tabpanel">
        <div class="card shadow-none border-0">
          <div class="card-body p-0">
            <h5 class="font-weight-bolder mb-3">Plantillas Guardadas</h5>
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Título</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Rol</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Mensaje</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in arrayTemplates" :key="index">
                    <td>
                      <p class="text-sm font-weight-bold mb-0 px-3">{{item.title}}</p>
                    </td>
                    <td>
                      <span class="badge badge-sm bg-gradient-secondary mx-3">{{item.permission}}</span>
                    </td>
                    <td>
                      <p class="text-xs text-muted mb-0 px-3 text-truncate" style="max-width: 250px;">
                        {{ stripTags(item.description) }}
                      </p>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-link text-danger text-gradient px-3 mb-0" @click="deleteTemplate(item._id)">
                        <font-awesome-icon icon="trash-can" class="me-1" />
                        Eliminar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3">
              <p class="text-xs text-muted mb-0">Total: {{pagination.totalRows}} plantillas</p>
              <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#82d616"
                @update:modelValue="reloadPaginate"
              />
            </div>
          </div>
        </div>
      </div>
      <!--      ======================== END TAB 2 =======================-->
      <!--      ======================== START TAB 3 =======================-->
      <div class="tab-pane fade" id="tab12" role="tabpanel">
        <div class="card shadow-none border-0">
          <div class="card-body p-0">
            <h5 class="font-weight-bolder mb-3">Envío Directo (Sin Plantilla)</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-control-label">Nombre del Destinatario</label>
                  <input class="form-control" placeholder="Ej: Juan Pérez" v-model="sms.user">
                </div>
                <div class="form-group mb-3">
                  <label class="form-control-label">Número de Teléfono</label>
                  <input class="form-control" placeholder="Ej: +584120000000" v-model="sms.to">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-control-label">Mensaje</label>
                  <textarea class="form-control" placeholder="Escribí tu mensaje aquí..." rows="5" v-model="sms.message"></textarea>
                </div>
                <button class="btn bg-gradient-success w-100" :disabled="disabled_button" @click="sendSmsOld">
                  <font-awesome-icon icon="paper-plane" class="me-1" />
                  Enviar SMS Ahora
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade show active" id="tab13" role="tabpanel">
        <div class="card shadow-none border-0">
          <div class="card-body p-0">
            <h5 class="font-weight-bolder mb-3">Enviar usando Plantilla</h5>
            <div class="form-group mb-4">
              <label class="form-control-label">Seleccionar Plantilla</label>
              <select class="form-control form-control-lg" @change="selectTemplate($event.target.value)">
                <option value="">-- Seleccioná una plantilla --</option>
                <option :value="item._id" v-for="item in arrayTemplates" :key="item.id">{{item.title}}</option>
              </select>
            </div>

            <div v-if="template_selected !== ''" class="row">
              <div class="col-lg-7">
                <div class="card bg-gray-100 border-radius-lg p-3 mb-4">
                  <h6 class="text-uppercase text-xs font-weight-bolder mb-3">Variables de la Plantilla</h6>
                  <div class="form-group mb-3">
                    <label class="form-control-label">Número de Destino</label>
                    <input class="form-control bg-white" placeholder="Ej: +584120000000" v-model="sms.to">
                  </div>
                  <div v-for="(field, index) in inputFields" :key="index" class="form-group mb-3">
                    <label class="form-control-label text-capitalize">{{ getFieldLabel(field.variable) }}</label>
                    <input class="form-control bg-white" v-model="field.value" :class="{ 'is-invalid': field.value === '' }" @input="fillTemplate">
                    <div v-if="field.value === ''" class="invalid-feedback">Este campo es requerido</div>
                  </div>
                </div>
              </div>
              
              <div class="col-lg-5">
                <h6 class="text-uppercase text-xs font-weight-bolder mb-3 text-center">Vista Previa del SMS</h6>
                <div class="iphone-x">
                  <div class="screen">
                    <div class="chat-header text-center">
                      <p class="mb-0 text-xs font-weight-bold">{{ sms.to || 'Número Destino' }}</p>
                      <small class="text-xxs text-muted">Mensaje de Texto</small>
                    </div>
                    <div class="chat-body p-2">
                      <div class="message received" v-if="filledTemplate" v-html="filledTemplate"></div>
                      <div class="message received loading" v-else>
                        <p class="mb-0 italic text-muted">Completá los campos para ver la previa...</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="d-flex gap-2 mt-4">
                  <button class="btn bg-gradient-success flex-grow-1 mb-0" :disabled="disabled_button || areFieldsEmpty" @click="sendSms">
                    <font-awesome-icon icon="paper-plane" class="me-1" />
                    Enviar SMS
                  </button>
                </div>
              </div>
            </div>
            
            <div v-else class="text-center py-5">
              <font-awesome-icon icon="arrow-up" size="3x" class="text-muted mb-3 opacity-3" />
              <p class="text-muted">Seleccioná una plantilla arriba para empezar a configurar el envío.</p>
            </div>
          </div>
        </div>
      </div>
      <!--      ======================== END TAB 4 =======================-->

    </div>
  </div>

</div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {get, post} from "@/utils/httpRequest";
import {decrypt} from "@/utils/encrypt";
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faFileCirclePlus, 
  faList, 
  faKeyboard, 
  faPaperPlane, 
  faCopy, 
  faCircleInfo, 
  faSave, 
  faTrashCan,
  faArrowUp
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faFileCirclePlus, faList, faKeyboard, faPaperPlane, faCopy, faCircleInfo, faSave, faTrashCan, faArrowUp);

export default {
  components: {
    FontAwesomeIcon
  },
  data: () => ( {
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    },
    template_selected: '',
    editor: ClassicEditor,
    editorData: '',
    editorConfig: {
      language: 'es',
      rows: 10,
      height: 500,
      toolbar: {
        items: [
          'bold',
          'italic',
          'link',
          'undo',
          'redo'
        ]
      },
    },
    arrayTemplates: [],
    template: {
      permission: 'all',
      title: '',
      description: '',
    },
    inputFields: [],
    filledTemplate: '',
    sms: {
      user: '',
      to: '',
      message: ''
    },
    disabled_button: false,
    sms_supplier: {
      sms_supplier: '',
      _id: '',
    },
  }),
  computed: {
    areFieldsEmpty() {
      return this.inputFields.some(field => field.value === '');
    }
  },
  mounted() {
    this.getTemplates();
  },
  methods: {
    async saveTemplate() {
      if(!this.$userCan('administrator')){
        const store = localStorage.getItem('payment-admin-type');
        this.template.permission = decrypt(store);
      }
      if (this.template.title !== '' && this.template.description !== '' && this.containsPlaceholder(this.template.description)) {
        await post("sms/create-template", {...this.template});
        this.template = {
          permission: 'all',
          title: '',
          description: '',
        }
        await this.getTemplates();
        await this.$swal({
          html: 'Proceso completado con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        })
      }else{
        this.$swal({
          icon: 'error',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          html: 'Por favor, completá todos los campos y asegurate de que el mensaje contenga al menos una variable ${variable}',
        })
      }
    },
    async deleteTemplate(id) {
      await this.$swal({
        showCancelButton: true,
        confirmButtonText: 'SÍ, eliminar',
        cancelButtonText: `NO, cancelar`,
        confirmButtonColor: '#ea0606',
        html: '¿Estás seguro de que querés eliminar esta plantilla?'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post("sms/delete-template", {_id: id});
          await this.getTemplates();
        }
      })
    },
    async getTemplates() {
     const {data} =  await get(`sms/get-templates?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`);
      this.arrayTemplates = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },
    async selectTemplate(value) {
      this.template_selected = ''
      this.inputFields = []
      this.filledTemplate = ''
      this.sms = {
        user: '',
        to: '',
        message: ''
      }
      if (value !== '') {
        this.template_selected = this.arrayTemplates.find(item => item._id === value);
        this.parseTemplate()
      }
    },
     parseTemplate() {
      const regex = /\${(.*?)}/g;
      const matches = this.template_selected.description.match(regex);
      if (matches) {
        this.inputFields = matches.map(match => ({
          variable: match,
          value: ''
        }));
      }
    },
    getFieldLabel(variable) {
      return variable.replace(/\${|}/g, '');
    },
     async fillTemplate() {
      if (this.areFieldsEmpty) {
        return;
      }

      let filledTemplate = this.template_selected.description;
      for (const field of this.inputFields) {
        filledTemplate = filledTemplate.replace(field.variable, field.value);
      }
      this.filledTemplate = filledTemplate;
    },
    containsPlaceholder(text) {
      const regex = /\${.*?}/;
      return regex.test(text);
    },
    async sendSms(){
      this.disabled_button = true
      await this.fillTemplate()
      this.sms.message = this.filledTemplate
      if(this.sms.to !== '' && this.sms.message !== ''){
        const {data} = await post('sms/send-sms',{to: this.sms.to, message: this.sms.message})
        await post('sms/create-sms',{...this.sms, response: data})
        await this.$swal({
          html: '¡SMS enviado con éxito!',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });
      }else{
        this.disabled_button = false
        await this.$swal({
          html: 'Por favor, completá el número de destino y generá la vista previa del mensaje',
          icon: 'error',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        })
      }
    },
    async sendSmsOld(){
      this.disabled_button = true
      if(this.sms.to !== '' && this.sms.message !== ''){
        const {data} = await post('sms/send-sms',{to: this.sms.to, message: this.sms.message})
        await post('sms/create-sms',{...this.sms, response: data})
        await this.$swal({
          html: '¡SMS enviado con éxito!',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });
      }else{
        this.disabled_button = false
      }
    },
    reloadPaginate(page){
      this.pagination.page = page
      this.getSms()
    },
    copyToClipboard() {
      const content = "${}";
      const input = document.createElement("input");
      input.value = content;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    },
    stripTags(text) {
      return text ? text.replace(/<\/?[^>]+(>|$)/g, "") : "";
    }
  }
};

</script>


<style scoped lang="scss">
.nav-pills .nav-link {
  border: 1px solid transparent;
  transition: all 0.2s ease;
  
  &.active {
    background-color: #f8f9fa;
    border-color: #e9ecef;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    
    .icon {
      background-image: linear-gradient(310deg, #7928ca 0%, #ff0080 100%);
      svg { color: white !important; }
    }
    
    .nav-link-text {
      color: #344767;
    }
  }
  
  &:hover:not(.active) {
    background-color: #f8f9fa;
  }
}

.iphone-x {
  position: relative;
  width: 100%;
  max-width: 280px;
  height: 400px;
  background: #fff;
  border-radius: 30px;
  box-shadow: 0 0 0 8px #111, 0 0 0 10px #222, 0 20px 40px rgba(0,0,0,0.2);
  margin: 0 auto;
  overflow: hidden;
  
  .screen {
    width: 100%;
    height: 100%;
    background: #e5ddd5;
    display: flex;
    flex-direction: column;
  }
  
  .chat-header {
    background: #f6f6f6;
    padding: 25px 10px 10px;
    border-bottom: 1px solid #ddd;
  }
  
  .chat-body {
    flex-grow: 1;
    overflow-y: auto;
    background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png');
    background-repeat: repeat;
  }
}

.message {
  max-width: 85%;
  padding: 8px 12px;
  border-radius: 15px;
  margin-bottom: 10px;
  font-size: 0.75rem;
  line-height: 1.4;
  position: relative;
  
  &.received {
    background: #fff;
    align-self: flex-start;
    border-bottom-left-radius: 2px;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    
    &.loading {
      background: rgba(255, 255, 255, 0.7);
      border: 1px dashed #ccc;
    }
  }
}

.is-invalid {
  border-color: #ea0606 !important;
}

.invalid-feedback {
  display: block;
  font-size: 0.75rem;
  color: #ea0606;
  margin-top: 0.25rem;
}

:deep(.ck-editor__editable) {
  min-height: 200px;
}
</style>
